// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CybersecurityTrainingPage from './pages/CybersecurityTrainingPage.jsx'; // if you already created it
import RedTeamPage from './pages/RedTeamPage.jsx';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services/cybersecurity-training" element={<CybersecurityTrainingPage />} />
                <Route path="/services/red-team" element={<RedTeamPage />} />
                {/* Optional: add fallback */}
                {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
        </Router>
    );
};

export default App;
